import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors, rt) => ({
  header: {
    paddingTop: theme.spacing[8],
    paddingBottom: theme.spacing[5],
  },
  headerActions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing[2],
  },
  headerAction: {
    borderColor: colors.borderSubtle,
    borderWidth: 1,
    borderRadius: theme.borderRadius.xs,
  },
  bottomSheet: {
    flex: 1,
    backgroundColor: colors.cartBackground,
  },
  bottomSheetContentContainer: {
    flex: 1,
    backgroundColor: colors.cartBackground,
  },
  bottomSheetContent: (maxHeight: boolean = false) => ({
    flex: 1,
    overflow: 'hidden',
    borderTopLeftRadius: theme.borderRadius.m,
    borderTopRightRadius: theme.borderRadius.m,
    backgroundColor: colors.cartBackground,

    paddingBottom: rt.insets.bottom + theme.spacing[4],
    paddingTop: maxHeight ? rt.insets.top + theme.spacing[2] : 0,
    minHeight: maxHeight ? rt.screen.height : rt.screen.height * 0.9,
    _web: {
      paddingHorizontal: theme.spacing[5],
    },
  }),
  cartItemsScrollView: {
    flex: 1,
  },
  cartItemsScrollViewContent: {
    rowGap: theme.spacing[4],
  },
  spaceBetween: {
    justifyContent: 'space-between',
  },
  groupAppointmentCard: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: colors.cartBorder,
  },

  timeButton: {
    height: 48,
  },
  nextAvailableTimeButton: {
    borderColor: colors.cartBorder,
  },
  subtotalLabel: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing[3],
  },
}));
